export default __webpack_public_path__ + "static/media/dropdown-arrow-white.5d08ace4.svg";